import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import { italianInItaly } from '@sbt-web/utils';
import styles from './index.module.scss';
const createHumanizedDate = function (date?: string): string | null {
  if (!date) {
    return null;
  }
  const epochTimestamp = Date.parse(date);
  if (Number.isNaN(epochTimestamp)) {
    console.error(`The date ${date} is an invalid date`);
    return null;
  }
  const messageDate = new Date(epochTimestamp);
  const monthAndYear = messageDate.toLocaleDateString(italianInItaly, {
    year: 'numeric',
    month: 'long'
  });
  return `Pubblica da ${monthAndYear}`;
};
export const PrivateUserAccountAge = t0 => {
  const $ = _c(7);
  const {
    firstAdInsertionDate,
    style
  } = t0;
  if (!firstAdInsertionDate) {
    return;
  }
  let t1;
  if ($[0] !== firstAdInsertionDate) {
    t1 = createHumanizedDate(firstAdInsertionDate);
    $[0] = firstAdInsertionDate;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const humanizedDate = t1;
  let t2;
  if ($[2] !== style) {
    t2 = classNames("body-text", "small", styles.accountAge, style);
    $[2] = style;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== humanizedDate || $[5] !== t2) {
    t3 = <p className={t2}>{humanizedDate}</p>;
    $[4] = humanizedDate;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};